import { Stack, Avatar, Typography, TextField, RadioGroup, FormControlLabel, Radio } from "@mui/material";
import axios from "axios";
import { useState } from "react";
import FormDialog from "src/components/common/FormDialog";
import MerchantPicker from "src/components/common/MerchantPicker";
import UserPicker from "src/components/common/UserPicker";
import FormItem from "src/components/form-item/FormItem";
import { alert } from "src/services/alert";
import { asyncRequest } from "src/services/network";

const ChannelAddDialog = ({ item, open, onClose, onUpdate }) => {
  const [form, setForm] = useState({
    mid: item.mid || "",
    phone: item.phone || "",
    userName: item.userName || "",
    certId: item.certId || "",
    cardName: item.cardName || "",
    cardNo: item.cardNo || "",
    userId: item.userId || "",
  });

  const [merchant, setMerchant] = useState(item.mer || {});
  const [user, setUser] = useState({});

  function handleIptChange(ki, val) {
    // console.log(ki, val);
    setForm({
      ...form,
      [ki]: val,
    });
  }

  async function handleConfirm() {
    // if (!user.uid) return alert("请选择用户");
    if (!merchant.mid) return alert("请选择商户");

    const formData = {
      ...form,
      mid: merchant.mid,
    }

    if (item.id) {
      formData.id = item.id;
    }

    const { msg } = await asyncRequest({
      path: item.id ? "/merchant/channel/edit" : "/merchant/channel/add",
      data: formData,
    });

    alert(msg, "success");
    onUpdate();
  }

  function handleSelectMerchant() {
    MerchantPicker({
      onSelect(val) {
        console.log(val);
        setMerchant(val);

        setForm({
          ...form,
          mid: val.mid,
          userName: val.realname,
          cardName: val.realname,
          phone: val.mobile,
        })
      },
    });
  }

  function handleSelectUser() {
    UserPicker({
      onSelect(val) {
        console.log(val);
        setUser(val);
      },
    });
  }

  return (
    <FormDialog title={item.id ? '编辑三方用户' : "添加三方用户"} open={open} onClose={onClose} onConfirm={handleConfirm}>
      <FormItem title="商户" required sx={{ width: 500 }}>
        <TextField fullWidth placeholder="请选择商户" autoComplete="off" id="merchant" value={merchant.name || ""} size="small" onClick={() => handleSelectMerchant()} />
      </FormItem>

      <FormItem title="法人姓名" required>
        <TextField fullWidth placeholder="法人姓名" autoComplete="off" id="userName" value={form.userName} size="small" onChange={(e) => handleIptChange("userName", e.target.value)} />
      </FormItem>

      <FormItem title="身份证号" required>
        <TextField fullWidth placeholder="身份证号" autoComplete="off" id="certId" value={form.certId} size="small" onChange={(e) => handleIptChange("certId", e.target.value)} />
      </FormItem>

      <FormItem title="银行卡号" required>
        <TextField fullWidth placeholder="银行卡号" autoComplete="off" id="cardNo" value={form.cardNo} size="small" onChange={(e) => handleIptChange("cardNo", e.target.value)} />
      </FormItem>

      <FormItem title="卡主姓名" required>
        <TextField fullWidth placeholder="卡主姓名" autoComplete="off" id="cardName" value={form.cardName} size="small" onChange={(e) => handleIptChange("cardName", e.target.value)} />
      </FormItem>

      <FormItem title="预留手机号" required>
        <TextField fullWidth placeholder="预留手机号" autoComplete="off" id="phone" value={form.phone} size="small" onChange={(e) => handleIptChange("phone", e.target.value)} />
      </FormItem>

      <FormItem title="三方用户号" required>
        <TextField disabled={item.id} fullWidth placeholder="三方用户号" autoComplete="off" id="userId" value={form.userId} size="small" onChange={(e) => handleIptChange("userId", e.target.value)} />
      </FormItem>
    </FormDialog>
  );
};

export default ChannelAddDialog;
